<template>
  <div class="container-fluid vehicle-index-page">
    <div class="vehicle-index-container">
      <div class="listing-page">
        <div class="row">
          <div class="col-lg-12">
            <div id="srp-title" class="vehicles-found-container">
              <h1><span class="srp-title">Vehicles in City, US</span></h1>
              <div>
                <span class="vehicles-found"
                  >{{ selectedBrandVehicles.length || "" }} vehicles available
                  for sale</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row vehicle-sort-menu" role="complementary">
          <div class="col-md-3 col-md-offset-9 col-xs-12">
            <div class="text-center">
              <div class="btn-group" role="group">
                <button
                  id="mobile-refine-results"
                  class="btn btn-default visible-sm visible-xs"
                  aria-controls="sticky-menu-container"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  Refine Results
                </button>
                <div class="btn-group">
                  <button
                    id="sortResultsDropdown"
                    class="btn btn-default dropdown-toggle"
                    aria-expanded="false"
                    aria-controls="sort-results"
                    aria-haspopup="listbox"
                    data-toggle="dropdown"
                    type="button"
                  >
                    Sort Results <span class="caret"></span>
                  </button>
                  <ul
                    id="sort-results"
                    class="dropdown-menu"
                    aria-labelledby="sortResultsDropdown"
                    role="listbox"
                  >
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Discount: Highest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Price: Lowest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Price: Highest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Mileage: Lowest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Year: Newest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Year: Oldest First</span>
                      </a>
                    </li>
                  </ul>
                  <button class="btn btn-default" id="toggle-model-search">
                    <i class="fa fa-car"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <SideFilerMenu :headerColor="brandColors['--primary-color']" :brand="brand"  />
          <div
            class="col-lg-10 col-md-9 col-sm-12"
            id="vehicles"
            role="main"
            aria-labelledby="srp-title"
            tabindex="-1"
          >
            <GridVehicle
              v-for="vehicle in selectedBrandVehicles"
              :key="`vehicle-${vehicle.modelName}`"
              v-bind="{
                vehicle,
                price: getRandomPrice(),
                priceBtnTitle: priceBtn.title,
                selectedPriceBtn,
                isLockedPricingSelected,
                brandColors,
                brand
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SideFilerMenu from "./srp-child-components/SideFilterMenu.vue";
import GridVehicle from "./srp-child-components/GridVehicle.vue";

export default {
  name: "grid-based-search-results",
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      prices: [
        {
          market: 39488,
          belowMarket: 36284,
        },
        {
          market: 49583,
          belowMarket: 44413,
        },
        {
          market: 27995,
          belowMarket: 24089,
        },
        {
          market: 36999,
          belowMarket: 32494,
        },
      ],
    };
  },
  computed: {
    ...mapState(["chosenBrand", "chosenComponents", 'buttonComponents']),
    ...mapGetters(["brandData", "selectedBrandVehicles"]),
    isLockedPricingSelected() {
      return !!this.chosenComponents.find((c) => c.title === "Locked Pricing");
    },
    priceBtn() {
      let component = this.chosenComponents.find(c => c.type === 'get-price-btn')
      if (!component) {
        component = this.findDefaultButton()
      }
      return component
    },
    selectedPriceBtn() {
      const brandBtn = this.priceBtn.previews.find((p) =>  {
        for (var i = 0; i < p.brands.length; i++) {
          if (p.brands[i].toLowerCase() === this.brand.toLowerCase()) {
            return p
          }
        }
      })
      if (brandBtn) {
        return brandBtn
      }
      return this.priceBtn.previews.find(c => c.primary)
    },
    brandColors() {
      return this.brandData.colors;
    },
  },
  methods: {
    getRandomPrice() {
      return this.prices[Math.floor(Math.random() * this.prices.length)];
    },
    findDefaultButton() {
      if (this.isLockedPricingSelected) {
        return this.buttonComponents.lockedPricing.find(c => c.type === 'get-price-btn')
      }
      return this.buttonComponents.unlockedPricing.find(c => c.type === 'get-price-btn')
    }
  },
  components: {
    GridVehicle,
    SideFilerMenu,
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
/*srp filter menu*/
.sort-menu-container .fa-check:before {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 17px;
}

.sort-menu-container .fa-plus:before {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 17px;
}

.sort-menu-container a.filter-button.section-heading {
  color: #333333 !important;
  font-size: 15px;
}

.sort-menu-container a.filter-button.section-heading.active i {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.sort-menu-container a.filter-button.section-heading.active i {
  transform: rotate(180deg);
}

.vehicles-found-container h1 {
  margin: 0 15px 0 0;
  display: inline-block;
  max-width: 50%;
  font-size: 18px;
}

.vehicles-found-container div {
  float: right;
  max-width: calc(50% - 15px);
  text-align: right;
}

@media (max-width: 991px) {
  .vehicles-found-container {
    padding: 15px !important;
    color: #ffffff;
    background-color: #000000;
  }

  .sort-menu-container {
    position: relative;
  }

  .row.vehicle-sort-menu > .col-md-3 > .text-center {
    text-align: center;
  }

  .listing-page .col-lg-12 {
    padding: 0px;
  }

  button#mobile-refine-results {
    color: rgba(0, 0, 0, 0.87);
    background-color: transparent;
    border-color: rgba(0, 0, 0, 0.87);
    font-weight: 700;
    font-family: var(--bold-text);
    font-size: 10.5px;
    text-transform: uppercase;
  }

  button#mobile-refine-results:hover,
  button#mobile-refine-results:focus {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    outline: none;
  }

  .sort-menu-container button {
    color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    background-color: transparent;
    font-weight: 700;
    font-family: var(--bold-text);
    max-width: 250px;
    margin: 10px auto;
    text-transform: uppercase;
  }

  .sort-menu-container button:hover,
  .sort-menu-container button:focus {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    outline: none;
  }

  .vehicle-filter-menu.hidden-sm.hidden-xs {
    display: block !important;
    height: 0;
  }
}

.stacked-srp-prices .single-stacked-price {
  margin-top: 0px;
}

.vehicle-unit-container {
  box-shadow: 2px 2px 5px rgb(47, 47, 47, 25%);
}

@media (min-width: 992px) {
  .vehicle-unit-container {
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }

  .vehicle-unit-container:hover {
    -webkit-transform: translateY(-5px);
    -ms-transform: translateY(-5px);
    transform: translateY(-5px);
    -webkit-box-shadow: 0 1px 30px rgb(47, 47, 47, 68%);
    box-shadow: 0 0px 30px rgb(47, 47, 47, 50%);
  }

  .vehicles-found-container h1 {
    flex-grow: 1;
    font-size: 18px;
    margin: 0 15px 0 0;
    font-weight: 400;
  }

  .sticky-side-menus {
    width: 100%;
  }

  .waitMe_container .waitMe {
    margin: 0 15px 0px 48px;
  }

  .filer-panel {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .listing-page > .row {
    position: relative;
  }

  .listing-page > .row:first-child {
    background-color: #eb0a1e;
    display: table;
    width: 100%;
    margin: 0;
  }

  .listing-page > .row:first-child::before,
  .listing-page > .row:first-child::after {
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000000;
  }

  body .vehicle-filter-menu .panel .panel-heading,
  body .vehicle-search-menu .panel .panel-heading {
    background-color: #000000;
  }

  .listing-page > .row:first-child::before {
    left: -100%;
  }

  .listing-page > .row:first-child::after {
    right: -100%;
  }

  .vehicle-sort-menu::before {
    display: block;
    position: absolute;
    top: 0;
    left: calc(10px - 5%);
    width: calc(220px + 5%);
    height: 100%;
  }

  .listing-page > .row:last-child {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .listing-page > .row:last-child::before {
    display: block;
    position: absolute;
    top: 0;
    left: calc(10px - 5%);
    width: calc(10px + 5%);
    height: 100%;
  }

  .row.vehicle-sort-menu + .row > div[class*="col-"] {
    display: inline-grid;
  }

  .row.vehicle-sort-menu + .row > div[class*="col-"]:first-child {
    width: 230px;
    padding-right: 0;
  }

  .row.vehicle-sort-menu + .row > div[class*="col-"]:last-child {
    width: calc(100% - 230px);
    padding-left: 48px;
  }

  .vehicle-filter-menu a.section-heading .selected-icon {
    float: right;
    color: #333333;
  }
}

/*not media queries*/
#sticky-menu-container {
  z-index: 99999998;
}

.listing-page {
  padding-top: 0;
}

.mobile-shortcut-btns {
  display: none !important;
}

.vehicles-found-container .vehicles-found {
  font-weight: bolder;
  font-family: var(--bold-text);
}

span.vehicles-found + span {
  font-weight: 400;
}

.vehicle-index-page a:hover,
.vehicle-index-page a:focus {
  color: #23527c;
  text-decoration: none;
  outline: none;
}

.vehicle-index-page {
  position: relative;
  width: 100%;
  font-family: var(--body-text);
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  -moz-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  background: #fff;
  padding: 30px;
}

.vehicle-index-page h1 {
  font-family: var(--heading-text);
}

.vehicle-index-page h2, .vehicle-index-page h3, .vehicle-index-page h4, .vehicle-index-page h5, .vehicle-index-page h6 {
  font-family: var(--subheading-text);
}

.listing-page {
  background: transparent !important;
}

.listing-page .col-lg-12 {
  padding: 0;
}

.listing-page > .row:nth-child(2) {
  margin-top: 0;
}

.vehicles-found-container {
  padding: 15px 0;
  color: #fff;
  position: relative;
  z-index: 1;
  background: #000000;
}

#sortResultsDropdown {
  color: rgba(0, 0, 0, 0.87);
}

.vehicle-filter-menu .section-divider {
  border-bottom: none;
  min-height: 1px;
  clear: both;
  width: 100%;
  height: 1px;
}

/*sort results dropdown*/
.vehicle-sort-menu #sortResultsDropdown {
  color: black;
  font-weight: 500;
}

.vehicle-sort-menu #sortResultsDropdown:after {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

span.caret {
  display: none;
}

.vehicle-sort-menu .dropdown-menu {
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: unset;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}

.vehicle-sort-menu .dropdown-menu > li > a {
  color: rgba(0, 0, 0, 0.84);
  font-weight: 500;
  padding: 6px 12px;
}

.vehicle-sort-menu .dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-image: none;
  background-color: rgba(0, 0, 0, 0.04);
}

/*sort results dropdown*/

/*vehicle card style*/
.vehicle-toggle-btn {
  display: none;
}

.vehicle-index-summary span.pull-right {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
  font-weight: 500;
  font-family: var(--bold-text);
}

.vehicle-index-summary span {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}

.vdp-link {
  display: none;
}

/*vehicle price block*/
.stacked-srp-prices h3 {
  font-weight: 500;
  font-style: normal;
}

.vehicle-price h3 {
  width: 40%;
  float: right;
  text-align: right;
  font-size: 18px;
}

.vehicle-price h5 {
  width: 60%;
  float: left;
  text-align: left;
  font-size: 14px;
}

.vehicle-price .locked-price h3 {
  width: 100%;
  margin-top: 5px;
}

.row.stacked-srp-prices .col-xs-6:first-child {
  width: 100%;
  text-align: center;
}

.vehicle-price-block .vehicle-prices .col-xs-6 {
  width: 100%;
}

h5.price-label {
  text-transform: uppercase;
  font-weight: 600 !important;
}

.lowest-price h3 {
  font-weight: 600;
}

/*vehicle price block*/

/*vehicle card style*/

/*back to top*/

.section-heading[onclick="window.scrollTo(0, 0);"] {
  position: fixed;
  height: 56px;
  padding: 16px !important;
  width: 56px;
  right: 20px;
  bottom: 20px;
  border-radius: 50%;
  z-index: 99999999;
  background-color: #333;
  color: #fff !important;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.section-heading[onclick="window.scrollTo(0, 0);"] > span {
  display: none;
}

/*back to top*/

/*range filter*/

.vehicle-filter-menu .irs-bar {
  background: #00324f;
  border-color: #00324f;
}

/*range filter*/

/*srp sort dropdown*/
.vehicle-sort-menu {
  background-color: transparent;
  padding: 10px 0;
}

.vehicle-sort-menu .text-center {
  text-align: right;
}

#sortResultsDropdown {
  background-color: transparent;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}

/*srp grid view*/
#vehicles {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  padding-top: 3px;
}

@media (max-width: 767px) {
  .vehicle-index-summary {
    padding-top: 65px;
  }

  #call-to-action-overlay {
    font-size: 35px;
  }
}

@media (min-width: 768px) {
  #vehicles > .vehicle-unit-container,
  .active-template-wrapper {
    width: calc(50% - 6px);
  }
}

@media (min-width: 1200px) {
  #vehicles > .vehicle-unit-container,
  .active-template-wrapper {
    width: calc(33.333% - 6px);
  }
}

@media (max-width: 991px) {
  .listing-page > .row:nth-child(3) > [class*="col-"]:first-child {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .listing-page > .row:nth-child(2) {
    height: fit-content;
    padding: 10px 15px 0px 15px;
  }
  .listing-page > .row:nth-child(3) > [class*="col-"]:first-child {
    padding: 0px 15px;
    text-align: center;
  }
  .listing-page > .row:nth-child(2) #mobile-refine-results,
  .listing-page > .row:nth-child(2) #sortResultsDropdown {
    margin: 0px 5px;
    padding: 10px;
    font-size: 11px;
    font-weight: bold;
    font-family: var(--bold-text);
    letter-spacing: 0.3px;
    text-transform: capitalize;
    width: 130px;
    height: 37px;
  }
  .listing-page > .row:nth-child(2) #mobile-refine-results {
    background-color: #000000;
    color: #ffffff;
  }
  .listing-page > .row:nth-child(2) #sortResultsDropdown {
    background-color: #555555;
    color: #ffffff;
  }
  .vehicle-sort-menu #sortResultsDropdown:focus {
    outline: 0px;
  }
}

.vehicle-bottom {
  margin-top: auto;
  padding: 0 10px;
}

.vehicle-index-container {
  margin: 0 auto;
  max-width: 1440px;
}

.vehicle-index-container h4.special-title {
  text-align: center;
  padding-top: 5px;
}

.srp-special > .row:last-child {
  margin: 0;
  border-bottom: 1px dashed red;
}

.srp-special > .row:last-child > div[class*="col"] {
  padding: 0 0 5px;
}

.vehicle-badges {
  margin: 0 -5px;
}

.vehicle-badges > a {
  display: inline-block;
  width: calc(33.333% - 10px);
  margin: 0 5px;
}

div:not(.accordion-col) .vehicle-certification-badge {
  margin: auto 0;
  max-width: 100%;
  height: auto;
}

.infinite-paginate > .row {
  display: none;
}

/*srp sort dropdown*/
.vehicle-sort-menu {
  background-color: transparent;
  padding: 10px 0;
}

.vehicle-sort-menu .text-center {
  text-align: right;
}

#sortResultsDropdown {
  background-color: transparent;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}

/*srp grid view*/
#vehicles {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}

@media (max-width: 767px) {
  .vehicle-index-summary {
    padding-top: 65px;
  }
}

.vehicle-bottom {
  margin-top: auto;
  padding: 0 10px;
}

.vehicle-index-container h4.special-title {
  color: red;
  border-top: 1px dashed red;
  text-align: center;
  padding-top: 5px;
}

.srp-special > .row:last-child {
  margin: 0;
  border-bottom: 1px dashed red;
}

.srp-special > .row:last-child > div[class*="col"] {
  padding: 0 0 5px;
}

div:not(.accordion-col) .vehicle-certification-badge {
  margin: auto 0;
  max-width: 100%;
  height: auto;
}

.infinite-paginate > .row {
  display: none;
}

.vehicle-title h4 {
  margin-top: 12px;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.vehicle-title h4:hover {
  text-decoration: underline;
}

.vehicle-spex {
  text-align: center;
}

.vehicle-spex .strong {
  font-weight: 600;
  font-family: var(--bold-text);
}

.index-btns {
  width: 90%;
  margin-bottom: 30px;
}

.row.stacked-vehicle-prices,
.vehicle-price .row {
  margin: auto;
}

.vehicle-price {
  padding: 15px 0px 0px;
}

.new-false .vehicle-price {
  padding: 15px 0 0 0;
}

.vehicle-price .lowest-price h5 {
  margin-top: 5px !important;
}

.vehicle-spex .row {
  margin: auto;
}

.vehicle-spex .spex-box {
  padding: 5px;
  background: #f5f5f5;
  border-radius: 6px;
  margin: 10px auto;
}

.new-false .vehicle-price-block {
  padding-bottom: 0px;
}

.vehicle-price-block .highest-price {
  color: #333;
}

.vehicle-title {
  padding-right: 15px;
  padding-left: 15px;
}
.vehicle-thumb {
  text-align: center;
}
</style>